import React from "react";
import QuoteStepBase from '../components/QuoteStepBase'
import IncidentInfo from '../components/IncidentInfo'
import QuoteStep from "./QuoteStepLayout";
import { IDriverStepProps, IQuoteStepState } from "../components/interfaces";
import { IAppState } from "../state/interfaces";
import { connect } from "react-redux";
import { QUOTE_STEPS, COMPONENTS } from "../AppConstants";
import { ValidatableForm } from "../components/ValidatableForm"
import Utilities from "../classes/Utilities";
import { IIncidentInfo, IQuoteApiClient, IPaths } from "../classes/Domain";
import ButtonContinue from "../components/ButtonContinue";
import QuoteActions from "../state/appActions";


interface IState extends IQuoteStepState {
    incidents: Array<IIncidentInfo>;
}

export interface IProps extends IDriverStepProps {
    quoteApiClient: IQuoteApiClient,
    PATHS: IPaths;
}

class Incidents extends QuoteStepBase<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.next = this.next.bind(this);
        this.onIncidentChange = this.onIncidentChange.bind(this);

        this.state = {
            incidents: this.props.driver.incidents && 0 < this.props.driver.incidents.length
                ? this.props.driver.incidents
                : [{ id:0, type: "", month: null, year: null, description: "" }],
            updatingStore: false,
            errors: null
        };
    }

    componentDidMount() {
        super.componentDidMount();
        this.props.reportCurrentStep();
    }

    setStateValue(value: string, property: string) {
        const obj = {};
        obj[property] = value;
        this.setState({ ...this.state, ...obj });
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        //if (nextProps.meta.propsSource === COMPONENTS.PROPS_SOURCES.APP_STORE) {
        //    const driver = nextProps.driver;
        //    nextProps.meta.propsSource = "";

        //    if (null === driver) return prevState;

        //    return {
        //        ...prevState,
        //        firstName: driver.firstName,
        //        lastName: driver.lastName,
        //        birthDate: driver.birthDate,
        //        gender: driver.gender,
        //        maritalStatus: driver.maritalStatus
        //    };
        //}

        return prevState;
    }

    onIncidentChange(incident: IIncidentInfo, index: number) {

    }

    next() {
        this.setState({ updatingStore: true }, () => {
            const updatedDriver = {
                ...this.props.driver,
                firstName: this.state.firstName,
                lastName: this.state.lastName,
                birthDate: this.state.birthDate,
                gender: this.state.gender,
                maritalStatus: this.state.maritalStatus
            };

            this.props.updateAppState({ quoteUid: this.props.quoteUid, driver: updatedDriver })
                .then(() => this.props.history.push(Utilities.formatUrl(/*PATHS.EDUCATION_EMPLOYMENT*/ this.props.PATHS.YOUR_HOME, (0 < this.props.driverIndex ? this.props.driverIndex + "" : ""))),
                    () => {
                        this.setState({ ...this.state, updatingStore: false });
                    });
        });
    }

    render() {
        return (
            <QuoteStep id={this.props.id}>
                <div className="titleArea"><h5>YOUR INCIDENT DETAILS</h5></div>
                <ValidatableForm hasErrors={null != this.state.errors}>
                    {
                        this.state.incidents.map((incident, incidentIndex) => (
                            <IncidentInfo
                                key={Utilities.uniqueId()}
                                incident={incident}
                                index={incidentIndex}
                                onChange={this.onIncidentChange} />
                        ))
                    }
                    
                    <div className="btnContainer">
                        <ButtonContinue
                            disabled={this.state.updatingStore}
                            showLoading={this.state.updatingStore}
                            onClick={this.next} />
                    </div>
                </ValidatableForm>
            </QuoteStep>
        );
    }
}

let mapProps = (state: IAppState, ownProps: IDriverStepProps) => {
    var driverIndex = !ownProps.match.params["driverIndex"]
        ? 0
        : parseInt(ownProps.match.params["driverIndex"], 10);

    return {
        quoteUid: state.quoteUid,
        driverIndex: driverIndex,
        driver: driverIndex < state.drivers.length ? state.drivers[driverIndex] : null,
        meta: { propsSource: COMPONENTS.PROPS_SOURCES.APP_STORE },
        stateCode: state.stateCode
    };
};

let mapDispatch = (dispatch: any, ownProps: IProps) => {
    var quoteActions = new QuoteActions(ownProps.quoteApiClient);

    return {
        reportCurrentStep: () => dispatch(quoteActions.quoteStepChanged(QUOTE_STEPS.DRIVING_HISTORY)),
        updateAppState: (update) => dispatch(quoteActions.updateDriver(update.quoteUid, update.driver, QUOTE_STEPS.ABOUT_YOU))
    };
};

export default connect(mapProps, mapDispatch)(Incidents);
